import './index.less';

import { Button } from '@bfe/moly';
import { CoinProtectIcon } from '@bfe/moly-icons';
import { useEffect, useState } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';
import { requestRegulationInfo } from '@/services/user';

const SubText = ({
  positionLimit,
  dailyTradingLimit,
}: {
  positionLimit: string;
  dailyTradingLimit: string;
}) => {
  const [$t] = useI18nContext();

  return (
    <div className="riskAssets-subText">
      <div className="riskAsset-subText-item">
        <span className="riskAssets-subText-label">{$t('positionLimit')}:</span>
        <span className="riskAssets-subText-value">{positionLimit} HKD</span>
      </div>
      <div className="riskAsset-subText-item">
        <span className="riskAssets-subText-label">
          {$t('dailyTradingLimit')}:
        </span>
        <span className="riskAssets-subText-value">
          {dailyTradingLimit} HKD
        </span>
      </div>
    </div>
  );
};

const RiskAssessment = () => {
  const [$t] = useI18nContext();

  const [positionLimit, setPositionLimit] = useState('--');
  const [dailyTradingLimit, setDailyTradingLimit] = useState('--');

  useEffect(() => {
    requestRegulationInfo().then((res: any) => {
      setPositionLimit(res?.result?.extendInfo?.positionLimit);
      setDailyTradingLimit(res?.result?.extendInfo?.dailyTradingLimit);
    });
  }, []);

  const handleAssessmentBtn = () => {
    window.location.href =
      '/user/assets/questionnaire/?productId=100028&from=kyc';
  };

  return (
    <>
      <AccountBasicItem
        icon="riskAssets"
        molyIcon={<CoinProtectIcon />}
        text={$t('RiskAssessment')}
        subText={
          <SubText
            positionLimit={positionLimit}
            dailyTradingLimit={dailyTradingLimit}
          />
        }
        operation={
          <>
            <Button
              onClick={() => handleAssessmentBtn()}
              size="small"
              data-radius="small"
              variant="primary"
            >
              {$t('assessment')}
            </Button>
          </>
        }
      />
    </>
  );
};

export default RiskAssessment;
